/*
  GWP Remove button (ECSR-1432, ECSR-1631)
  Cart lines whose SKU is listed in the "GWP SKU to Hide Qty Selector" theme
  setting show a Remove button in place of the quantity selector. Selecting it
  removes the line through the cart API and rebuilds the cart drawer and cart
  page in place, so the shopper stays on the current page.

  Gifts added by an EG Auto Add to Cart rule carry a line property (the app's
  "addedItemIdentifier", "_Gifted" here) whose value is the rule name. The app
  wraps window.fetch and, for a rule with "prevent product removal" on, rewrites
  any quantity change on such a line back to its current quantity, so a plain
  /cart/change.js call never removes it. For those lines the request is sent as
  one of the app's own internal requests, which it leaves untouched, and the
  rule is marked as already run this session with the app's own key so it does
  not add the gift again on a later cart update.
*/
(function () {
  var selectors = {
    button: '[data-gwp-remove]',
    easyGiftShop: '#easygift-shop'
  };

  var easyGift = {
    internalParam: '_easygift_internal=true',
    defaultIdentifier: '_Gifted',
    sessionKeyPrefix: 'easygift-'
  };

  function easyGiftSettings() {
    var meta = document.querySelector(selectors.easyGiftShop);
    if (!meta) {
      return null;
    }

    try {
      var shop = JSON.parse(meta.getAttribute('content'));
      return (shop && shop.settings) || {};
    } catch (e) {
      return {};
    }
  }

  // Name of the EG rule that added this line, or '' for a gift added by hand.
  function giftRuleName(button, settings) {
    if (!settings) {
      return '';
    }

    var properties;
    try {
      properties = JSON.parse(button.getAttribute('data-gwp-properties') || 'null');
    } catch (e) {
      return '';
    }

    if (!properties) {
      return '';
    }

    var identifier = settings.addedItemIdentifier || easyGift.defaultIdentifier;
    var value = propertyValue(properties, identifier);
    return value ? String(value) : '';
  }

  // Liquid renders a line's properties as an array of [name, value] pairs;
  // the cart API returns them as an object. Accept either.
  function propertyValue(properties, name) {
    if (Array.isArray(properties)) {
      for (var i = 0; i < properties.length; i++) {
        var pair = properties[i];
        if (Array.isArray(pair) && pair[0] === name) {
          return pair[1];
        }
      }
      return '';
    }

    if (typeof properties === 'object' && Object.prototype.hasOwnProperty.call(properties, name)) {
      return properties[name];
    }

    return '';
  }

  // True when the response is a cart and the removed line is no longer in it.
  function lineRemoved(cart, key) {
    if (!cart || !Array.isArray(cart.items)) {
      return false;
    }

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i] && cart.items[i].key === key) {
        return false;
      }
    }
    return true;
  }

  // Record the rule as already run this session, in the same storage and key
  // the app reads for "Only execute the rule once per session".
  function rememberRemoval(ruleName, settings) {
    var key = easyGift.sessionKeyPrefix + ruleName;

    try {
      if (settings.useLocalStorage && settings.useLocalStorage.enabled) {
        if (!localStorage.getItem(key)) {
          localStorage.setItem(key, JSON.stringify({ value: true, timestamp: new Date() }));
        }
      } else {
        sessionStorage.setItem(key, 'true');
      }
    } catch (e) {
      // Storage unavailable (private mode); the removal itself still stands.
    }
  }

  function removeLine(key, ruleName) {
    if (!ruleName) {
      return theme.cart.changeItem(key, 0);
    }

    return theme.cart._updateCart({
      url: ''.concat(theme.routes.cartChange, '?', easyGift.internalParam, '&t=', Date.now()),
      data: JSON.stringify({
        id: key,
        quantity: 0
      })
    });
  }

  function onClick(evt) {
    var button = evt.target.closest(selectors.button);
    if (!button || !window.theme || !theme.cart) {
      return;
    }

    evt.preventDefault();

    if (button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var key = button.getAttribute('data-gwp-remove');
    if (!key) {
      return;
    }

    var settings = easyGiftSettings();
    var ruleName = giftRuleName(button, settings);

    button.setAttribute('aria-disabled', 'true');

    removeLine(key, ruleName)
      .then(function (cart) {
        if (!lineRemoved(cart, key)) {
          button.removeAttribute('aria-disabled');
          return;
        }

        if (ruleName) {
          rememberRemoval(ruleName, settings);
        }

        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
      })
      .catch(function () {
        button.removeAttribute('aria-disabled');
      });
  }

  // Bind once, straight away, on document. theme.js is also deferred and runs
  // first, so its page:loaded event has already fired by the time this file
  // executes; waiting for it would leave the button unbound. Delegating from
  // document survives the cart drawer re-rendering its contents, and theme.cart
  // is checked at click time rather than at bind time.
  if (window.gwpRemoveBound) {
    return;
  }
  window.gwpRemoveBound = true;
  document.addEventListener('click', onClick);
})();
